export const DESKTOP_MENU_BAR_LIMIT = 9;
